export const DEVICE_SIZES = {
  mobile: '320px',
  tablet: '768px',
  laptop: '1366px',
  desktop: '1600px',
};